/**
 * Copyright (C) Radiojar S.A. - All Rights Reserved
 * Unauthorized copying of this file, via any medium is strictly prohibited
 * Proprietary and confidential
 *
 * Created by Tasos Kolokathis on 1/7/21.
 */

import config from "@/config"
import axios from "axios";
import store from "@/store";

export default {
	getPages(objectId) {
		return axios.get(`${config.ZETTA_URL}/playlist/bytype/${objectId}/7`, {
			headers: {
				"Authorization": store.state.accessToken,
				"z-cloud-org-id": store.getters.getOrgID()
			}
		});
	},

	createPage(page) {
		return axios.post(`${config.ZETTA_URL}/playlist`, page, {
			headers: {
				"Authorization": store.state.accessToken,
				"z-cloud-org-id": store.getters.getOrgID()
			}
		});
	},

	updatePage(page) {
		return axios.put(`${config.ZETTA_URL}/playlist/${page.PlaylistID}`, page, {
			headers: {
				"Authorization": store.state.accessToken,
				"z-cloud-org-id": store.getters.getOrgID()
			}
		});
	},

	deletePage(pageId) {
		return axios.delete(`${config.ZETTA_URL}/playlist/${pageId}`, {
			headers: {
				"Authorization": store.state.accessToken,
				"z-cloud-org-id": store.getters.getOrgID()
			}
		});
	},

	addHotKey(data) {
		return axios.post(`${config.ZETTA_URL}/event`, data, {
			headers: {
				"Authorization": store.state.accessToken,
				"z-cloud-org-id": store.getters.getOrgID()
			}
		});
	},

	patchHotKey(hotKeyEventId, data) {
		return axios.patch(`${config.ZETTA_URL}/event/${hotKeyEventId}`, data, {
			headers: {
				"Authorization": store.state.accessToken,
				"z-cloud-org-id": store.getters.getOrgID()
			}
		});
	},

	deleteHotKey(hotKeyEventId) {
		return axios.delete(`${config.ZETTA_URL}/event/${hotKeyEventId}`, {
			headers: {
				"Authorization": store.state.accessToken,
				"z-cloud-org-id": store.getters.getOrgID()
			}
		});
	},
}
